<template>
    <InfoPopup />
    <div id="liveAlertPlaceholder" class="alert-container"></div>
    <component :is="layout">
      <router-view />
    </component>   
</template>

<script>
import EmptyLayout from "./components/layouts/EmptyLayout.vue";
import MainLayout from "./components/layouts/MainLayout.vue";
import { mapMutations, mapGetters } from 'vuex';
import InfoPopup from './components/app/InfoPopup.vue';

export default {
  name: 'App',
  components: {
    EmptyLayout,
    MainLayout,
    InfoPopup,
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'main') + '-layout';
    },
  },
  mounted() {
    this.updateWindowWidth(window.innerWidth);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations('ui', ['SET_WINDOW_WIDTH']),
    handleResize() {
      this.updateWindowWidth(window.innerWidth);
    },
    updateWindowWidth(width) {
      this.SET_WINDOW_WIDTH(width);
    }
  },
};
</script>


<style lang="scss">

.alert-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1050; /* ensure it appears above other elements */
}
</style> 
  